// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1kBi4","title":"InfoRow_title__N2yF1"};